<template lang="pug">
  .main-container.min-view-height.relative
    lottie.not-found-animation(:options='optionsNotFound')
    .not-found-text-container.column.absolute
      span.text-normal.gray.m-bottom-1
        | {{ $t('notFound.error') }}
      span.title-medium.error-text
        | {{ $t('notFound.somethingWrong') }}
      span.text-normal.error-text
        | {{ $t('notFound.unavailablePage') }}
      router-link.text-normal.bold.blue(to='/feed')
        | {{ $t('notFound.backToHome') }}
</template>

<script>
import Lottie from 'vue-lottie'

import notFound from '@/assets/lottie/error404.json'

export default {
  components: { Lottie },
  data() {
    return {
      optionsNotFound: { animationData: notFound, loop: false }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/sizes';
@import 'src/scss/variables/colors';

.not-found-icon {
  border-right: 1px solid $light-gray;
  margin-right: 120px;
  padding-right: 120px;
}

.not-found-text-container {
  left: 60%;
  top: 50%;
  transform: translateY(-50%);
  width: 224px;
}

.error-text {
  margin-bottom: 16px;
}

.not-found-animation {
  max-width: 1400px;
}
</style>
